import { render, staticRenderFns } from "./EventsCalendar.vue?vue&type=template&id=4b53b106&scoped=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=js"
export * from "./EventsCalendar.vue?vue&type=script&lang=js"
import style0 from "./EventsCalendar.vue?vue&type=style&index=0&id=4b53b106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53b106",
  null
  
)

export default component.exports